import { Paperclip } from 'lucide-react';
import { useIntl } from 'react-intl';

import {
  MAX_FILES,
  useOnboardingFiles,
} from '@/features/onboarding-v2/hooks/useOnboardingFiles';
import { Button } from '@heidi/design-system/button';
import { FileUploadButton } from '@heidi/design-system/file-upload';
import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipTrigger,
} from '@heidi/design-system/tooltip';

import { personalizationSharedMessages } from '@heidi/growth';

export const OnboardingUploadFileButton = ({ isPending }: { isPending: boolean }) => {
  const intl = useIntl();
  const { files, handleFilesAccepted } = useOnboardingFiles();
  const isMaxFilesReached = files.length >= MAX_FILES;
  const isDisabled = isPending || isMaxFilesReached;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        {/* span wrapper keeps the tooltip discoverable while the inner Button is disabled */}
        <span>
          <FileUploadButton
            asChild
            multiple
            accept=".doc,.docx,.pdf"
            disabled={isDisabled}
            onFilesAccepted={handleFilesAccepted}
          >
            <Button
              type="button"
              variant="outline"
              size="md"
              iconOnly={files.length === 0}
              disabled={isDisabled}
              aria-label={intl.formatMessage(personalizationSharedMessages.attachFiles)}
              data-testid="onboarding-upload-button"
            >
              <Paperclip />
              {files.length > 0 && `${files.length}`}
            </Button>
          </FileUploadButton>
        </span>
      </TooltipTrigger>
      <TooltipContent side="top">
        {intl.formatMessage(
          isMaxFilesReached
            ? personalizationSharedMessages.maximumFilesReached
            : personalizationSharedMessages.uploadExampleNotes
        )}
        <TooltipArrow />
      </TooltipContent>
    </Tooltip>
  );
};
